export const jsonDevelopment =
{
    "mtServiceUrl": "/api",
    "GoogleApiWrapper": "AIzaSyBpirc3QTYyZ4M8bpx0QfWTyvPtoYELXtM"
};
